import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Plus, Car } from "lucide-react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/lib/auth";
import { getNavItems } from "@/components/layout/navConfig";
import { Button } from "@/components/ui/button";

export const Sidebar = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { sidebar } = getNavItems(user?.role);

  return (
    <aside className="fixed inset-y-0 left-0 z-40 hidden w-64 flex-col border-r border-border bg-card lg:flex">
      <div className="flex h-16 items-center gap-2.5 border-b border-border px-5">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-navy text-primary-foreground">
          <Car className="h-5 w-5" />
        </div>
        <div className="leading-tight">
          <div className="font-display text-base font-extrabold tracking-tight text-foreground">RVSF CRM</div>
          <div className="text-[11px] text-muted-foreground">Vehicle Sourcing</div>
        </div>
      </div>

      <div className="px-4 py-4">
        <Button className="w-full" variant="brand" size="lg" onClick={() => navigate("/leads/new")}>
          <Plus className="h-4 w-4" /> New Lead
        </Button>
      </div>

      <nav className="flex-1 space-y-1 px-3">
        {sidebar.map((item) => {
          const Icon = item.icon;
          const active = item.end ? pathname === item.to : pathname.startsWith(item.to);
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={cn(
                "flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
                active
                  ? "bg-accent text-accent-foreground"
                  : "text-muted-foreground hover:bg-secondary hover:text-foreground"
              )}
            >
              <Icon className="h-[18px] w-[18px]" />
              {item.label}
            </NavLink>
          );
        })}
      </nav>

      <div className="border-t border-border p-4">
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-primary text-sm font-semibold text-primary-foreground">
            {(user?.full_name || "?").slice(0, 1)}
          </div>
          <div className="min-w-0">
            <div className="truncate text-sm font-semibold text-foreground">{user?.full_name}</div>
            <div className="truncate text-[11px] text-muted-foreground">
              {user?.role === "team_leader" ? "Team Leader" : "Employee"}
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};
